<div class="flex justify-content-between align-items-center">
    {{ label }}
    <p-sortIcon *ngIf="sorteable" [field]="field"></p-sortIcon>
    <p-columnFilter *ngIf="field"
        type="text"
        [field]="field"
        display="menu"
        class="ml-auto"
        [showMatchModes]="false"
        [showOperator]="false"
        [showAddButton]="false">
        <ng-template pTemplate="header">
            <div class="px-3 pt-3 pb-0">
                <span class="font-bold">Filtro {{ label }}</span>
            </div>
        </ng-template>
    </p-columnFilter>
</div>
